module.exports = __webpack_public_path__ + "img/nature_pin_selected.fde8be79.png";